export const logisticsContent = {
    id: "logistics",
    route: "/logistika",
    menuTitle: "Logistika",
    title: "Projektová logistika a průmyslové dodávky",
    headline: "Projektová logistika pro energetiku, průmysl a veřejný sektor",
    lead: "23 let zkušeností s logistikou, průmyslovými dodávkami a technickými projekty po celé Evropě.",
    summary: "Vlastní logistický areál NOBI v Kličanech u Prahy, skladování, konsolidace dodávek, kontrola kvality, mezinárodní logistika a koordinace montáží po celé EU.",
    primaryItems: [
        "3 600 m² krytých skladových ploch",
        "3 000 m² venkovních manipulačních ploch",
        "vlastní manipulační technika",
        "konsolidace dodávek z celé Evropy",
        "příprava technologických celků před montáží",
        "skladování ocelových konstrukcí a energetických zařízení"
    ],
    sections: [
        {
            title: "Logistický areál NOBI – Kličany u Prahy",
            items: [
                "kryté skladové plochy",
                "venkovní manipulační plochy",
                "vlastní technika",
                "příprava technologických celků"
            ]
        },
        {
            title: "Specializace",
            items: [
                "ocelové trubky do délky 12 m",
                "těžké ocelové plechy",
                "potrubní systémy a fitinky",
                "energetické technologie",
                "bateriová úložiště",
                "nabíjecí stanice",
                "technologické kontejnery",
                "nadrozměrné přepravy"
            ]
        },
        {
            title: "Co zákazník získá",
            items: [
                "technický dohled nad výrobou",
                "kontrolu kvality",
                "kontrolu materiálových certifikátů",
                "organizaci výroby",
                "skladování",
                "mezinárodní logistiku",
                "manipulaci na stavbě",
                "koordinaci montáže"
            ]
        }
    ],
    specializations: [
        "ocelové trubky do 12 m",
        "těžké ocelové plechy",
        "fitinky",
        "energetické technologie",
        "bateriová úložiště",
        "nabíjecí stanice",
        "technologické kontejnery",
        "nadrozměrné přepravy"
    ],
    customerGains: [
        "technický dohled",
        "kontrola kvality",
        "mezinárodní logistika",
        "koordinace montáže"
    ]
};
